import { Route } from '@angular/router';
import { CoveragesListComponent } from './ui/coverages-list/coverages-list.component';

const coveragesRoutes: Route[] = [
    {
        path: 'coverages',
        component: CoveragesListComponent,
    }
];

export default coveragesRoutes;
